import { PageHeader } from '@/components/layout/page-header';
import { FxSwapsPanel } from '@/features/fx-swaps/fx-swaps-panel';

const FxSwapsPage = () => {
  return (
    <div className="flex min-h-full w-full flex-col gap-4">
      <PageHeader documentTitle="FX Swaps - Bespoke Ops Portal - One Trading" title="FX Swaps" />
      <FxSwapsPanel />
    </div>
  );
};
FxSwapsPage.displayName = 'FxSwapsPage';

export default FxSwapsPage;
